import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { CommunityService } from '../../services/community/community.service';
import { ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-view-community',
    templateUrl: './view-community.component.html',
    styleUrls: ['./view-community.component.scss'],
    standalone: false
})
export class ViewCommunityComponent implements OnInit {
  communityName: string = '';
  communityId: number | null = null;
  invitationWebpageLink: string = '';
  surveyWebpageLink: string = '';

  constructor(private communityService: CommunityService,
    private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.communityId = Number(this.route.snapshot.paramMap.get('id')) || null;
    this.getCommunityDetails();
  }

  getCommunityDetails() {
    if (this.communityId) {
      this.communityService.getCommunity(this.communityId).subscribe((data) => {
        const community = data?.data;
        if (community) {
          this.communityName = community.title || 'مجتمع تلال الرياض';
          this.invitationWebpageLink = community.invitation_webpage_link || '';
          this.surveyWebpageLink = community.survey_webpage_link || '';
        }
      });
    }
  }
}
